export default {
  salePrice: '销售价',
  dealPrice: '活动价',
  standard: '常规报名',
  standardRules: '按活动规则校验',
  flexible: '报名条件更灵活',
  summary: '平台邀约以下 {count} 个 SKU 报名本活动',
  total: '共 {count} 个 SKU',
  product: '商品',
  marketplaceProduct: '平台类目商品',
  inventory: '库存',
  registrationDetails: '报名信息',
  priceRequirements: '报名价格要求',
  averagePrice: '近30天平均成交价',
  averagePriceHint: '近 30 天平均成交价；无成交样本时使用当前售价。',
  remove: '移除商品',
  emptySelection: '已移除全部商品，请关闭后重新选择。',
  selectedSummary: '已选择 {count} 个 SKU，其中 {invited} 个受邀商品',
  open: '报名已开启',
  notOpen: '报名尚未开启',
  closed: '报名已截止',
  all: '全部商品',
  invited: '受邀商品',
  tag: '活动邀约',
  count: '{count} 个商品收到活动邀约',
  homeNotice: '{products}收到活动邀约',
  productCount: '{count} 个商品',
  description: '这些商品近期表现不错，平台建议您报名参加本活动。报名条件更灵活，报名价不得高于页面展示的最高报名价。',
  suggestedPrice: '建议活动价',
  maxRegistrationPrice: '最高报名价',
  registrationPrice: '报名价',
  approvedPriceCap: '已通过报名价上限',
  registrationType: '报名类型',
  rejectionReason: '本次拒绝原因',
  previousRejectionReason: '上次拒绝原因',
  FREE: '自由报名',
  STORE_WHITELIST: '店铺白名单',
  INVITED: '受邀商品',
  positivePrice: '请输入大于 0 的整数价格。',
  belowSalePrice: '报名价必须低于当前售价。',
  maximumPrice: '最高可报 {amount}',
  submitted: '提交成功，请在管理大促活动商品页面查看报名状态。',
  partial: '{count} 个商品处理成功，当前仅保留未成功商品。'
}
